export default {
  // Hero
  'archive.hero.kicker': 'Tate Protest Presents',
  'archive.hero.title': 'THE ARCHIVE',
  'archive.hero.subtitle': 'The Record Is On Tape',
  'archive.hero.accessing': 'ACCESSING VIDEO ARCHIVE_',
  'archive.hero.selectScreen': 'SELECT A SCREEN',
  'archive.featured.eyebrow': 'Featured video',
  'archive.featured.selectedEyebrow': 'Selected video',
  'archive.featured.unavailableTitle': 'Featured tape unavailable',
  'archive.featured.unavailableBody': 'The featured archive tape is not available right now. Please use the TV wall below to select another tape.',

  // Architect door
  'archive.door.enter': 'Enter The Matrix',

  // TV screens
  'archive.tv.accessDenied': 'ACCESS DENIED',

  // Terminal status + CTA (page footer)
  'archive.status.active': 'ARCHIVE STATUS: ACTIVE',
  'archive.status.newTapes': 'NEW TAPES ADDED AS PROCEEDINGS DEVELOP',
  'archive.cta.description': 'These archive tapes are part of the Tate Protest documentary record. For the complete legal timeline and case documentation, visit the case pages directly.',
  'archive.cta.legalTimeline': 'Legal Timeline',
  'archive.cta.evidence': 'Evidence Board',
  'archive.cta.getInvolved': 'Get Involved',

  // Video player
  'archive.player.subtitles': 'Subtitles',
  'archive.player.ccOff': 'Turn subtitles off',
  'archive.player.ccEn': 'English subtitles',
  'archive.player.ccEs': 'Subtítulos en español',
  'archive.player.ccDe': 'Deutsche Untertitel',
  'archive.player.archiveFootage': 'ARCHIVE FOOTAGE',
  'archive.player.sourcePending': 'SOURCE PENDING',
  'archive.player.sourcePreparing': 'Video source being prepared for archive insertion.',
  'archive.player.tape': 'TAPE',
  'archive.player.originalSource': 'Original Source',
  'archive.player.viewSource': 'View Source',
  'archive.player.copied': 'Copied',
  'archive.player.share': 'Share',
  'archive.player.close': 'CLOSE ARCHIVE',
  'archive.player.rewind': 'Rewind 10s',
  'archive.player.forward': 'Forward 10s',
  'archive.player.play': 'Play video',
  'archive.player.pause': 'Pause video',
  'archive.player.volume': 'Video volume',
  'archive.player.fullscreen': 'Enter fullscreen',

  // Shared categories
  'archive.categories.investigation': 'Investigation',
  'archive.categories.newsReport': 'News Report',
  'archive.categories.parliamentaryDebate': 'Parliamentary Debate',
  'archive.categories.legalProceedings': 'Legal Proceedings',
  'archive.categories.witnessStatement': 'Witness Statement',
  'archive.categories.civilLitigation': 'Civil Litigation',
  'archive.categories.expertCommentary': 'Expert Commentary',
  'archive.categories.movementHistory': 'Movement History',
  'archive.categories.pressArchive': 'Press Archive',
  'archive.categories.demonstrationArchive': 'Demonstration Archive',
  'archive.categories.interview': 'Interview',

  // Shared dates
  'archive.dates.april2022': 'April 2022',
  'archive.dates.april122022': 'April 12, 2022',
  'archive.dates.august282022': 'August 28, 2022',
  'archive.dates.december2022': 'December 2022',
  'archive.dates.january192023': 'January 19, 2023',
  'archive.dates.january2024': 'January 2024',
  'archive.dates.2025Present': '2025 — Present',
  'archive.dates.romanianProceedings': 'Romanian Proceedings',
  'archive.dates.2024Present': '2024 — Present',
  'archive.dates.2023Present': '2023 — Present',
  'archive.dates.ongoing': 'Ongoing',
  'archive.dates.2022Present': '2022 — Present',
  'archive.dates.preArrest': 'Pre-Arrest Recording',
  'archive.dates.august272026': 'August 26, 2026',
  'archive.dates.august282026': 'August 27, 2026',

  // Related case labels
  'archive.related.viewRomania': 'View Romania Case',
  'archive.related.viewMatrix': 'View Matrix Attack',
  'archive.related.viewUk': 'View UK Case',
  'archive.related.viewUs': 'View U.S. Case',
  'archive.related.viewJaneDoe': 'View Jane Doe Case',
  'archive.related.viewPencov': 'View Pencov v. Doe Case',
  'archive.related.viewOnlineDefamation': 'View X Account-Disclosure Case',
  'archive.related.viewEvidence': 'View Evidence',
  'archive.related.aboutTates': 'About the Tates',
  'archive.related.getInvolved': 'Get Involved',
  'archive.related.viewArchive': 'View The Archive',

  // Video 001
  'archive.videos.latest-development.title': 'DIICOT Raid Captured on Andrew Tate\u2019s CCTV \u2014 April 2022',
  'archive.videos.latest-development.description': 'Andrew Tate\u2019s own compound CCTV captures Romanian DIICOT officers raiding the property in April 2022. Officers seized computers, cameras, and all electronic devices from the property as part of the initial criminal investigation.',

  // Video 002
  'archive.videos.diicot-seizure.title': 'DIICOT Seized Everything \u2014 Andrew Tate, April 12 2022',
  'archive.videos.diicot-seizure.description': 'Andrew Tate documents that DIICOT had seized all computers, cameras, and electronic devices from the compound. Personal footage showing the aftermath of the April 2022 raid \u2014 every device confiscated by Romanian authorities.',

  // Video 003
  'archive.videos.andrew-schulz-cancelled.title': 'Andrew Schulz Discusses Andrew Tate\u2019s Cancellation \u2014 August 28, 2022',
  'archive.videos.andrew-schulz-cancelled.description': 'Comedian Andrew Schulz discusses the cancellation of Andrew Tate in August 2022. Schulz examines the deplatforming campaign, the coordinated social media bans, and the broader implications for free speech and digital censorship.',

  // Video 004
  'archive.videos.bloomberg-arrest.title': 'Bloomberg News \u2014 Andrew Tate Detained in Romania on Trafficking and Rape Suspicions',
  'archive.videos.bloomberg-arrest.description': 'Social media influencer Andrew Tate has reportedly been detained in Romania on suspicion of human trafficking and rape. The former kickboxer was held alongside his brother, Tristan, and two other suspects while his house was raided in the capital, Bucharest.',

  // Video 005
  'archive.videos.uk-case.title': 'UK House of Commons \u2014 \u2018Tackling Misogyny in Schools\u2019 Debate, January 19 2023',
  'archive.videos.uk-case.description': 'Official UK House of Commons debate titled "Tackling Misogyny in Schools." MPs specifically discussed Andrew Tate\u2019s influence on school-aged boys, citing concerns raised by teachers across the country about his content reaching children in classrooms. Full official transcript available via Hansard.',

  // Video 006
  'archive.videos.cctv-footage.title': 'CCTV FOOTAGE \u2014 April 2022',
  'archive.videos.cctv-footage.description': 'Compound CCTV from April 2022 showing Girl A and Girl B entering and leaving the Tate property freely. The footage documents the two women coming and going from the compound of their own accord, without visible restriction.',

  // Video 007
  'archive.videos.victim-doe-3.title': 'Victim Doe 3 \u2014 Woman Listed as Victim Denies Victimization, Alleges Corruption',
  'archive.videos.victim-doe-3.description': 'A woman listed as a victim in the Romanian case states publicly that she is not a victim. One of four women who have come forward alleging corruption in the Romanian proceedings involving Andrew and Tristan Tate. Her statement challenges the foundational premise that all named complainants were in fact victims.',

  // Video 008
  'archive.videos.pencov-statement.title': 'Iasmina Pencov \u2014 \u201cNot a Victim\u201d Statement \u2014 January 2024',
  'archive.videos.pencov-statement.description': 'Iasmina Pencov, the named plaintiff in Pencov v. Doe, states in a January 2024 video that she is not a victim of the Tate brothers and wants nothing to do with the prosecution.',

  // Video 009
  'archive.videos.online-defamation.title': 'Tate v. X Corp. — Account Disclosure',
  'archive.videos.online-defamation.description': 'A signed corrected order dismissed the amended discovery complaint against X without prejudice. Clerk case info showed the action Open October 4, 2026; the returned X docket list runs through September 11 and does not establish later amendment compliance or a final with-prejudice dismissal.',

  // Video 010
  'archive.videos.legal-analysis.title': 'Legal Analysis & Commentary',
  'archive.videos.legal-analysis.description': 'Expert legal analysis of Tate proceedings. Attorney commentary, procedural breakdowns, and investigative reporting on the multi-jurisdictional legal battle.',

  // Video 011
  'archive.videos.the-evidence.title': 'The Evidence Board',
  'archive.videos.the-evidence.description': 'Documented evidence and key facts. Primary source documents, court filings, timeline entries, and verified public records across all jurisdictions.',

  // Video 012
  'archive.videos.tate-protest-history.title': 'Tate Protest History',
  'archive.videos.tate-protest-history.description': 'The story of Tate Protest as an independent advocacy platform. Origins, growth, key milestones, and the community-driven effort to document and share factual information.',

  // Video 013
  'archive.videos.media-coverage.title': 'Media Coverage Archive',
  'archive.videos.media-coverage.description': 'Compilation of international media coverage. News broadcasts, interviews, press conferences, and journalistic reporting on the Tate legal proceedings and public response.',

  // Video 014
  'archive.videos.protest-footage.title': 'Protest Footage',
  'archive.videos.protest-footage.description': 'Documented peaceful demonstrations and public gatherings. Footage from protests, rallies, and public advocacy events supporting the Tate brothers across multiple countries.',

  // Video 015
  'archive.videos.tate-jack-neel.title': 'Andrew Tate\u2019s Latest Interview \u2014 Podcast With Jack Neel \u2014 Recorded In Case of Arrest',
  'archive.videos.tate-jack-neel.description': 'Andrew Tate sits down with Jack Neel for what was described as his "latest interview" \u2014 a pre-recorded podcast episode intended to be released in the event of his arrest. Tate speaks candidly about the legal proceedings, the coordinated campaign against him, and his message to supporters if he were to be detained.',

  // Video 016
  'archive.videos.vivian-belt-video-statement.title': 'Vivian Addresses the Leaked \u201cBelt Video\u201d',
  'archive.videos.vivian-belt-video-statement.description': 'In this video statement, Vivian says the leaked footage commonly called the \u201cbelt video\u201d depicted consensual sexual play. Vivian has been described as a central alleged victim in connection with the September 2026 Romanian indictment. This archive presents her statement as her own account; it is not, by itself, a judicial finding about the allegations.',

  // Video 017
  'archive.dates.notProvided': 'Recording date not provided',
  'archive.videos.disruptors-clip.title': 'Tristan Speaking on Sexual Consent',
  'archive.videos.disruptors-clip.description': 'Tristan Tate discusses sexual consent in this user-supplied interview clip with a Disruptors watermark. The recording date and original publication link have not been provided.',
  'archive.videos.miami-protest.title': 'Miami Protest \u2014 August 27, 2026',
  'archive.videos.miami-protest.description': 'A 9:00 AM EDT peaceful demonstration at the C. Clyde Atkins U.S. Courthouse, 301 North Miami Avenue, Miami, Florida 33128, followed by the 10:00 AM EDT detention hearing.',
};